import { apiClient } from './api.js';
import { unwrap } from './api-error.js';
import type { ApiPaths } from '@reos/api-client';

/**
 * Krok H1 — fronta „K doplneni": otazky, na ktere server odpoved nenasel
 * a prebira je clovek (rozhodnuti R.B. 26. 9. 2026).
 *
 * Typy chodi z vygenerovaneho OpenAPI klienta, ne z rucniho interface - tvar
 * odpovedi drzi kontrakt API, ne domluva mezi dvema soubory (stejne jako
 * `human-tasks-api.ts`).
 */

export type ResolveUnknownTask =
  ApiPaths['/v1/duediligence/resolve-unknown']['get']['responses']['200']['content']['application/json']['items'][number];

export type ResolveUnknownStats =
  ApiPaths['/v1/duediligence/resolve-unknown/stats']['get']['responses']['200']['content']['application/json'];

export type ResolveUnknownAnswerBody =
  ApiPaths['/v1/duediligence/cases/{id}/human-tasks/{taskId}/answer']['post']['requestBody']['content']['application/json'];

export type ResolveUnknownAnswerResult =
  ApiPaths['/v1/duediligence/cases/{id}/human-tasks/{taskId}/answer']['post']['responses']['200']['content']['application/json'];

export interface ResolveUnknownFilter {
  readonly caseKind?: 'LAND' | 'HOUSE' | 'FLAT' | undefined;
  readonly sourceId?: string | undefined;
  readonly olderThanDays?: number | undefined;
  /** "Moje zakazky" (ADM1 bod 6) - CSV id zakazek, max 200. */
  readonly caseIds?: string | undefined;
  readonly limit?: number | undefined;
  readonly cursor?: string | undefined;
}

export const RESOLVE_UNKNOWN_PAGE_LIMIT = 25;

export interface ResolveUnknownPage {
  readonly items: ResolveUnknownTask[];
  readonly nextCursor: string | null;
}

/** Strankovana fronta „K doplneni" (ADM1 bod 6) - vychozi 25 na stranku. */
export async function listResolveUnknown(filter: ResolveUnknownFilter = {}): Promise<ResolveUnknownPage> {
  return unwrap(
    apiClient.GET('/v1/duediligence/resolve-unknown', {
      params: {
        query: {
          ...(filter.caseKind === undefined ? {} : { caseKind: filter.caseKind }),
          ...(filter.sourceId === undefined || filter.sourceId === ''
            ? {}
            : { sourceId: filter.sourceId }),
          ...(filter.olderThanDays === undefined ? {} : { olderThanDays: filter.olderThanDays }),
          ...(filter.caseIds === undefined || filter.caseIds === '' ? {} : { caseIds: filter.caseIds }),
          limit: filter.limit ?? RESOLVE_UNKNOWN_PAGE_LIMIT,
          ...(filter.cursor === undefined ? {} : { cursor: filter.cursor }),
        },
      },
    }),
  );
}

export async function getResolveUnknownStats(): Promise<ResolveUnknownStats> {
  return unwrap(apiClient.GET('/v1/duediligence/resolve-unknown/stats', {}));
}

/**
 * Odpoved cloveka. `openTasksRemaining === 0` znamena, ze tohle byl posledni
 * ukol zakazky - server pak sam vyzada novou revizi reportu (`exportId`).
 */
export async function answerResolveUnknown(
  caseId: string,
  taskId: string,
  body: ResolveUnknownAnswerBody,
): Promise<ResolveUnknownAnswerResult> {
  return unwrap(
    apiClient.POST('/v1/duediligence/cases/{id}/human-tasks/{taskId}/answer', {
      params: { path: { id: caseId, taskId } },
      body,
    }),
  );
}
